/**
 * Decide what to send for an optional numeric field (e.g. set/price) on save:
 * - a number (incl. an explicit 0) is sent as-is;
 * - an emptied field that originally had a value → null (clears it backend-side);
 * - a field that never had a value → undefined (dropped from the JSON payload).
 *
 * Relies on the same undefined-is-omitted behaviour that the request builders
 * already use for `id`, so the backend gets no key rather than a null/0.
 */
export function resolveClearableField(
  current: number | null | undefined,
  original: number | null | undefined,
): number | null | undefined {
  if (typeof current === "number") return current;
  return typeof original === "number" ? null : undefined;
}
